"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const events_1 = require("../constants/events");
const webVitals_1 = require("../constants/webVitals");
const sortEndEvents_1 = __importDefault(require("../events/sortEndEvents"));
/**
 * Add any defined metrics and attribution details for Web Vitals supported by
 * the browser
 *
 * @param {ClientProfiler} clientProfiler - ClientProfiler instance
 * @param {Object} opts - The beacon options.
 */
function flushWebVitals(clientProfiler, opts) {
    var _a;
    const { CLS: CLSName, TTFB: TTFBName } = events_1.EVENT_NAMES.WEB_VITALS;
    const { webVitalsMetrics } = clientProfiler;
    webVitals_1.ACTIVE_WEB_VITALS.forEach(metricName => {
        var _a;
        const metric = webVitalsMetrics[metricName];
        const attrib = metric.getAttribution();
        const endEvent = metric.getValueEvent(
        // >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        // When CLS or TTFB _are_ supported by the browser, create duplicate
        // "fixed" end events for corrected values by overriding the
        // `eventName` argument to `getValueEvent()` to include the "Fixed"
        // suffix in the event name. This will allow us to compare them to
        // the legacy end events which are always added regardless of
        // browser support.
        // E.g., when CLS is supported, `CLS` and `CLS-fixed` will both be
        // included in the beacon. When CLS is not supported, only `CLS`
        // will be included to the beacon.
        [CLSName, TTFBName].includes(metricName) &&
            events_1.EVENT_NAMES.WEB_VITALS[`${metricName}Fixed`]
        // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
        );
        if (endEvent)
            opts.eventsEnd.push(endEvent);
        if (attrib) {
            const attribName = `${metricName}Attribution`;
            ((_a = opts.webVitalsDetails) !== null && _a !== void 0 ? _a : (opts.webVitalsDetails = {}))[attribName] = attrib;
        }
    });
    // >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Always
    // Add CLS end events even if it's not supported by the browser to match
    // legacy behavior so we don't break existing monitoring. Similarly, the
    // legacy TTFB metric is added by navigationTimings.getTimeToFirstByteOnce()
    // in flushEvents.js.
    const CLSEndEvent = webVitalsMetrics.CLS.getValueEvent();
    if (CLSEndEvent)
        opts.eventsEnd.push(CLSEndEvent);
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
    // Sort end events by name for consistent ordering
    (0, sortEndEvents_1.default)(opts.eventsEnd);
    // Add `badCLSEntries` if there are any
    const badCLSEntries = webVitalsMetrics.CLS.getBadCLSEntries();
    if (badCLSEntries) {
        ((_a = opts.webVitalsDetails) !== null && _a !== void 0 ? _a : (opts.webVitalsDetails = {})).badCLSEntries = badCLSEntries;
    }
    return opts;
}
exports.default = flushWebVitals;
